module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-17.0c738b92.png";